module.exports = __webpack_public_path__ + "img/check.95a4a6c1.svg";